import { z } from 'zod';

import { companySchema } from 'entities/Company';
import { roleSchema, roleTextMap, Role } from 'types/Role';
import { createFullName } from 'utils/createFullName';

export const userRole = roleSchema;
export const USER_ROLES_ALL = new Set<UserRole>(userRole.options);

const nullishStringSchema = z.string().nullish();

export const userSchema = z
  .object({
    id: z.number(),
    first_name: z.string(),
    last_name: nullishStringSchema,
    patronymic: nullishStringSchema,
    phone: z.string(),
    email: z.string(),
    role: userRole,
    blocked: z.boolean(),
    unread_notices: z.number().optional(),
    is_content_editor: z.boolean(),
    company_id: z.number().nullish(),
    company: companySchema,
    /** Директору головной приходит всегда (в т.ч. пустой), директору дочерней — не приходит. */
    child_companies: z.array(companySchema).optional(),
  })
  .transform((raw) => {
    const lastName = raw.last_name ?? null;
    const patronymic = raw.patronymic ?? null;
    const companyId = raw.company_id ?? raw.company?.id ?? null;

    return {
      id: raw.id,
      firstName: raw.first_name,
      lastName,
      patronymic,
      fullName: createFullName({
        firstName: raw.first_name,
        lastName,
        patronymic,
      }),
      phone: raw.phone,
      email: raw.email,
      role: raw.role,
      roleLabel: roleTextMap[raw.role],
      blocked: raw.blocked,
      notificationsUnreadCount: raw.unread_notices ?? 0,
      isContentEditor: raw.is_content_editor,
      companyId,
      company: raw.company,
      childCompanies: raw.child_companies ?? [],
      isChildCompanyDirector: raw.role === 'director' && raw.child_companies === undefined,
    };
  });

export type UserRole = Role;

export type UserEntityApi = z.input<typeof userSchema>;

export type UserEntity = z.infer<typeof userSchema>;

export type UserPersonalDataPatchApi = {
  first_name: string;
  last_name: string;
  patronymic: string | null;
  phone: string;
};
